import React from 'react';
import { UserProfile } from '../UserAccess/UserContext';
import { useUser } from '../UserAccess/useUser';
import useUserRequest from '../Common/useUserRequest';
import { HttpMethod } from '../Common/useFetch';

const devRequestFailed = (actionName: string) => {
  window.alert('Failed to ' + actionName);
}

const devRequestSuccessful = (actionName: string) => {
  window.alert('Successfully ' + actionName);
}

const DevTools = ({ user }: { user: UserProfile }) => {
  const addTransactions = useUserRequest<void>({
    path: `/api/dev/addTicketData/${user.selectedBusiness?.id}`,
    method: HttpMethod.POST
  }, {
    onSuccess: () => devRequestSuccessful("added transactions"),
    onError: () => devRequestFailed("add transactions"),
  });

  const addReceivingTransactions = useUserRequest<void>({
    path: `/api/dev/addReceivingTicketData/${user.selectedBusiness?.id}`,
    method: HttpMethod.POST
  }, {
    onSuccess: () => devRequestSuccessful("added receiving transactions"),
    onError: () => devRequestFailed("add receiving transactions"),
  });

  const simulateTankLevels = useUserRequest<void>({
    path: `/api/dev/addTankData/${user.selectedBusiness?.id}`,
    method: HttpMethod.POST
  }, {
    onSuccess: () => devRequestSuccessful("simulated tank levels"),
    onError: () => devRequestFailed("simulate tank levels"),
  });

  return <>
    <span className="dropdown-header">Dev Tools</span>
    <button
      className="btn-ghost-secondary dropdown-item btn btn-link"
      onClick={() => addTransactions.request()}>
      <strong>Add Transactions</strong>
    </button>
    <button
      className="btn-ghost-secondary dropdown-item btn btn-link"
      onClick={() => addReceivingTransactions.request()}>
      <strong>Add Receiving Transactions</strong>
    </button>
    <button
      className="btn-ghost-secondary dropdown-item btn btn-link"
      onClick={() => simulateTankLevels.request()}>
      <strong>Simulate Tank Levels</strong>
    </button>
  </>
}

export default function DevToolsMenu() {
  const user = useUser();
  if (!user.isDevelopment) return null;

  return (
    <li className="nav-item dropdown d-flex align-items-center">
      <button
        className="btn btn-link border-0 p-0 lh-1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Dev tools"
        title="Dev Tools">
        <i className="bi-lightning-charge-fill fs-5" style={{ color: '#f5b400' }}></i>
      </button>
      <div className="dropdown-menu dropdown-menu-end dropdown-nav-menu">
        <DevTools user={user} />
      </div>
    </li>
  );
}
